import React, { useEffect } from "react";
import style from "./index.module.scss";
import { Button } from "antd";
import { FiClock } from "react-icons/fi";
import Countdown from "react-countdown";
import moment from "moment";
import { PaperProps } from "../../../../../service";
import { useInterval } from "react-use";
import useHeaderData from "../../../../Utils/useHeaderData";

interface TopicsProps {
    data?: PaperProps;
    barShow: () => void; //控制答题卡显示
    questionnaireId: string;
}

export default function QuestionnaireTopicsButtons({
    data,
    barShow,
    questionnaireId
}: TopicsProps) {
    const [headerData, stopStatus, reloadHeadData] =
        useHeaderData(questionnaireId);

    useEffect(() => {
        reloadHeadData();
    }, [questionnaireId]);

    useInterval(reloadHeadData, stopStatus); // 5秒刷新数据

    //前端倒计时时间到了处理（后续可能加需求）
    function timeOutSubmit() {}

    return (
        <>
            {headerData && (
                <div className={style.root}>
                    <div className={style.container}>
                        <div className={style.title}>
                            共 {data?.topicCount || "0"} 题，
                            {data?.totalScore || "0"}分
                        </div>
                    </div>
                    <div className={style.right}>
                        {headerData.validityTime && (
                            <div className={style.time}>
                                <FiClock size={14} />
                                倒计时{" "}
                                <Countdown
                                    onComplete={() => timeOutSubmit()}
                                    daysInHours
                                    date={
                                        moment(headerData.startTime).valueOf() +
                                        headerData.validityTime * 60000
                                    }
                                />
                            </div>
                        )}
                        <Button className={style.btn} onClick={() => barShow()}>
                            答题卡
                        </Button>
                    </div>
                </div>
            )}
        </>
    );
}
